import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { CreateWorkEntryPermitComponent } from '../work-entry-permit/create-work-entry-permit/create-work-entry-permit.component';
import { SuccessModalComponent } from '../work-entry-permit/modals/success-modal/success-modal.component';
import { WorkEntryPermitDetailsComponent } from '../work-entry-permit/work-entry-permit-details/work-entry-permit-details.component';
import { ListOfTaRequestsComponent } from '../work-entry-permit/list-of-ta-requests/list-of-ta-requests.component';
import { ListOfClaRequestsComponent } from '../work-entry-permit/list-of-cla-requests/list-of-cla-requests.component';
import { ApproveModalComponent } from '../work-entry-permit/modals/approve-modal/approve-modal.component';
import { DeclineModalComponent } from '../work-entry-permit/modals/decline-modal/decline-modal.component';
import { SmeGroupsListComponent } from '../work-entry-permit/sme-groups/sme-groups-list/sme-groups-list.component';
import { SmeGroupViewComponent } from '../work-entry-permit/sme-groups/sme-group-view/sme-group-view.component';
import { SmeAssignedComponent } from '../work-entry-permit/modals/sme-assigned/sme-assigned.component';
import { LeadingZeroPipe } from '../shared/pipes/leading-zero.pipe';

const routes: Routes = [
  { path: '', component: CreateWorkEntryPermitComponent },
  { path: 'create-work-entry-permit', component: CreateWorkEntryPermitComponent },
  { path: 'list-ta-admin-requests', component: ListOfTaRequestsComponent },
  { path: 'list-cla-admin-requests', component: ListOfClaRequestsComponent },
  { path: 'work-entry-permit-details/:id', component: WorkEntryPermitDetailsComponent },
  { path: 'sme-groups', component: SmeGroupsListComponent },
  { path: 'sme-group-details/:id', component: SmeGroupViewComponent },
];


@NgModule({
  declarations: [
    CreateWorkEntryPermitComponent,
    SuccessModalComponent,
    WorkEntryPermitDetailsComponent,
    ListOfTaRequestsComponent,
    ListOfClaRequestsComponent,
    ApproveModalComponent,
    DeclineModalComponent,
    SmeGroupsListComponent,
    SmeGroupViewComponent,
    SmeAssignedComponent,
    LeadingZeroPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    AngularSvgIconModule.forRoot(),
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WorkpermitModule { }
